import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import { FeedingBaseRationGroup, FeedingPeriod } from './feeding.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/feeding');

export const getFeedingPeriodList = actionCreator.async<{}, FeedingPeriod[]>('GET_FEEDING_PERIOD_LIST');
export const getFeedingListPresets = actionCreator.async('GET_FEEDING_LIST_PRESETS');
export const updateFeedingOrder = actionCreator<{
  feedingPeriodId: string;
  newPosition: number;
  feedingId: string;
  formName: FormName;
}>('UPDATE_FEEDING_ORDER');
export const updateFeedingOrderLinkFeeding = actionCreator<{
  feedingPeriodId: string;
  baseFeedingId: string;
  feedingId: string;
  formName: FormName;
}>('UPDATE_FEEDING_ORDER_LINK_FEEDING');
export const updateFeedingOrderLinkBaseFeeding = actionCreator<{
  feedingPeriodId: string;
  feedingGroup: FeedingBaseRationGroup;
  formName: FormName;
}>('UPDATE_FEEDING_ORDER_LINK_BASE_FEEDING');
export const createFeedingPeriod = actionCreator.async<
  {
    formName: FormName;
  },
  FeedingPeriod
>('CREATE_FEEDING_PERIOD');
export const updateFeedingPeriod = actionCreator.async<FormName, FeedingPeriod>('UPDATE_FEEDING_PERIOD');
export const deleteFeedingPeriod = actionCreator.async<
  {
    id: string;
    formName: FormName;
  },
  string
>('DELETE_FEEDING_PERIOD');
